const l = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle cx="16" cy="16" r="16" />
        <path
            d="M16.495 10.222h.06l.308.002c.526.004 1.477.016 2.457.052l.49.02c1.06.048 2.075.128 2.539.259.65.182 1.162.72 1.336 1.403.292 1.145.313 3.445.315 3.779v.082c-.002.334-.023 2.634-.315 3.779-.174.683-.685 1.22-1.336 1.403-.5.141-1.639.222-2.784.27l-.49.017a91.05 91.05 0 01-2.52.045h-.222c-.718-.002-4.721-.03-5.793-.332-.65-.182-1.162-.72-1.336-1.403-.257-1.008-.304-2.91-.313-3.58l-.002-.2v-.05-.031l.002-.2c.009-.67.056-2.572.313-3.581.174-.683.685-1.22 1.336-1.403.964-.27 4.303-.32 5.485-.329l.308-.002h.061zm-1.536 3.087v4.938l4.133-2.488-4.133-2.45z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=youtube.es.CegTIqTc.js.map
